import React from 'react';
import PropTypes from 'prop-types';
import './FieldValidationMessage.css';

function FieldValidationMessage(_ref) {
  var touched = _ref.touched,
      error = _ref.error,
      warning = _ref.warning;
  if (!touched || !error && !warning) return null;
  return touched && (error && React.createElement('span', {
    className: 'FieldValidationMessage FieldValidationMessage--error'
  }, error) || warning && React.createElement('span', {
    className: 'FieldValidationMessage FieldValidationMessage--warning'
  }, warning));
}

FieldValidationMessage.propTypes = {
  touched: PropTypes.bool.isRequired,
  error: PropTypes.string,
  warning: PropTypes.string
};
export default FieldValidationMessage;